import { render, staticRenderFns } from "./SenderNoticeCard.vue?vue&type=template&id=b7ea5a12&"
import script from "./SenderNoticeCard.vue?vue&type=script&lang=js&"
export * from "./SenderNoticeCard.vue?vue&type=script&lang=js&"
import style0 from "./SenderNoticeCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports